<div class="info-cards-container">
  <!-- Termine Card -->
  <div class="item costum-mat-surface-container-lowest custom-elevation-z2">
    <div class="title-header costum-mat-primary-font-color">
      <span class="custom-title-large">Termine</span>
      <mat-icon class="material-icons-outlined">schedule</mat-icon>
    </div>
    <div class="card-content">
      <div class="custom-body-medium">Nach Vereinbarung</div>
    </div>
  </div>

  <!-- Trainingsorte Card -->
  <div class="item costum-mat-surface-container-lowest custom-elevation-z2">
    <div class="title-header costum-mat-primary-font-color">
      <span class="custom-title-large">Trainingsorte</span>
      <mat-icon class="material-icons-outlined">place</mat-icon>
    </div>
    <div class="card-content">
      <div class="custom-body-medium">Verschiedene Trainingsorte in Wangen und Haslach</div>
    </div>
  </div>
</div>